export const GET_BOM_SERIES = 'GET_BOM_SERIES';
export const GET_BOM_SERIES_SUCCESS = 'GET_BOM_SERIES_SUCCESS';
export const GET_BOM_SERIES_FAILED = 'GET_BOM_SERIES_FAILED';

export const ADD_BOM_SERIES = 'ADD_BOM_SERIES';
export const ADD_BOM_SERIES_SUCCESS = 'ADD_BOM_SERIES_SUCCESS';
export const ADD_BOM_SERIES_FAILED = 'ADD_BOM_SERIES_FAILED';

export const EDIT_BOM_SERIES = 'EDIT_BOM_SERIES';
export const EDIT_BOM_SERIES_SUCCESS = 'EDIT_BOM_SERIES_SUCCESS';
export const EDIT_BOM_SERIES_FAILED = 'EDIT_BOM_SERIES_FAILED';

export const DELETE_BOM_SERIES = 'DELETE_BOM_SERIES';
export const DELETE_BOM_SERIES_SUCCESS = 'DELETE_BOM_SERIES_SUCCESS';
export const DELETE_BOM_SERIES_FAILED = 'DELETE_BOM_SERIES_FAILED';

export const UPDATE_LAST_BOM_NUMBER = 'UPDATE_LAST_BOM_NUMBER';
export const UPDATE_LAST_BOM_NUMBER_SUCCESS = 'UPDATE_LAST_BOM_NUMBER_SUCCESS';
export const UPDATE_LAST_BOM_NUMBER_FAILED = 'UPDATE_LAST_BOM_NUMBER_FAILED';

export const SET_DEFAULT_BOM_SERIES = 'SET_DEFAULT_BOM_SERIES';
export const SET_DEFAULT_BOM_SERIES_SUCCESS = 'SET_DEFAULT_BOM_SERIES_SUCCESS';
export const SET_DEFAULT_BOM_SERIES_FAILED = 'SET_DEFAULT_BOM_SERIES_FAILED';